<template>
    <div>
        <label v-for="(val, key) in siteToggle" :key="val">
            <input
                type="radio"
                v-model="selectedToggle"
                :value="val"
                :checked="val === 'all'"
            />
            {{ key }}
        </label>

        <template v-if="selectedToggle === 'restricted'">
            <select2
                id="site-permission-select"
                v-model="selectedSites"
                :options="select2SiteOptions"
                :settings="{width: '100%', multiple: true}"
            />
        </template>

        <input
            type="hidden"
            name="sites[]"
            :value="getSelectedSites"
        >
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    name: 'UserSiteSelectionComponent',

    components: { Select2 },

    props: {
        initialSites: {
            type: String,
            required: true,
        },
        userViewableSites: {
            type: String,
            required: false,
            default: '',
        },
    },

    data: function () {
        return {
            sites: JSON.parse(this.initialSites),
            userSites: null,
            selectedSites: [],
            siteToggle: {
                'All Sites': 'all',
                'Restricted Access': 'restricted',
            },
            selectedToggle: 'all'
        }
    },

    computed: {
        select2SiteOptions: function() {
            const hasOptions = this.sites.length > 0

            if (!hasOptions) {
                return []
            }

            return this.sites.map((site) => {
                return {
                    id: site.id,
                    text: site.name,
                }
            })
        },

        getSelectedSites: function () {
            if (this.selectedToggle === 'all') {
                const val = this.sites.map(s => s.id)
                return JSON.stringify(val)
            }

            const val = this.selectedSites
            return JSON.stringify(val)
        }

    },

    mounted() {
        // This prop only gets passed on the edit screen.
        // Set the selectedSites value to the sites the user can see, to support showing them in the Select2.
        if (this.userViewableSites && this.userViewableSites !== '') {
            this.userSites = JSON.parse(this.userViewableSites)

            if (typeof this.userSites === 'object') {
                this.userSites = Array.from(this.userSites)
            }

            this.selectedSites = this.userSites.map(site => site.id)
        }

        // If the sites length is different to the selectedSites length, the user has been restricted to a subset of sites.
        // Set the toggle to "Restricted" and show the restricted sites in the Select2 box.
        if (
            (this.sites.length !== this.selectedSites.length)
            && this.selectedSites.length > 0
        ) {
            this.selectedToggle = 'restricted'
        }

        // If the selectedSites length is the same as the sites length, the user has access to all sites. Unselect all
        // selected sites in case admin wants to restrict sites.
        if (
            (this.sites.length === this.selectedSites.length)
            && this.selectedToggle === 'all'
        ) {
            this.selectedSites = []
        }
    },
}
</script>

<style scoped>
label {
    padding-right: 15px;
}
</style>
